export default {"src":"/_next/static/media/speedAnalyzerSmall.23993c3d.svg","height":65,"width":136};